import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { useMutation } from '@apollo/client';
import {
  FraudTokensQuery,
  UpdateFraudTokenMutation,
  UpdateFraudTokenMutationVariables,
} from '@pv/common/graphql/operations';
import { UPDATE_FRAUD_TOKEN_MUTATION } from './graphql';

interface EditFraudTokenDialogProps {
  open: boolean;
  onClose: () => void;
  token: FraudTokensQuery['fraudTokens'][number];
}

export const EditFraudTokenDialog = ({
  open,
  onClose,
  token,
}: EditFraudTokenDialogProps) => {
  const [notes, setNotes] = useState(token.notes || '');

  useEffect(() => {
    setNotes(token.notes || '');
  }, [token]);

  const [updateFraudToken] = useMutation<
    UpdateFraudTokenMutation,
    UpdateFraudTokenMutationVariables
  >(UPDATE_FRAUD_TOKEN_MUTATION);

  const handleSubmit = async () => {
    try {
      await updateFraudToken({
        variables: {
          id: token.id,
          notes: notes || null,
        },
      });

      onClose();
    } catch (error) {
      console.error('Error saving fraud token:', error);
    }
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Fraud Scanner Entry</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            paddingTop: 2,
          }}
        >
          <TextField
            label="Value"
            value={token.value}
            fullWidth
            disabled
            helperText={
              token.tokenType === 'message_text'
                ? 'Case-insensitive text pattern to match in messages'
                : 'Exact value to match'
            }
          />
          <TextField
            label="Notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            fullWidth
            multiline
            rows={3}
            helperText="Optional notes about this token"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!notes}>
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
};
